<template>
    <card>
        <template slot="header">
            <h3 class="card-title">Create Roles</h3>
        </template>
        <div class="row">
            <div class="col-md-6"> 
                <nav class="row">
                <ol class="breadcrumb arr-right bg-breadcrum">
                   <li class="breadcrumb-item">
                      <router-link to="/hr/dashboard"><i class="fa fa-home"></i>&nbsp;Dashboard</router-link>
                   </li>
                   <li class="breadcrumb-item">
                    <router-link to="/hr/usersroles">Roles</router-link>
                 </li>
                   <li class="breadcrumb-item active">Create Roles</li>
                </ol>
             </nav>
            </div>
          </div>
          <hr style="margin-top:-10px"/>
          <form @submit="formSubmit">
                <div class="row">
                   <div class="col-md-4">
                       <div class="form-group">
                             <label>Roles Name</label>
                             <input type="text" v-model="roles_name"  v-bind:class="{ 'is-invalid': error_handler && error_handler.roles_name}" class="form-control">
                             <span v-if="error_handler.roles_name" class=" invalid-feedback">{{ error_handler.roles_name[0] }}</span>
                        </div>  
                        <div class="form-group">
                             <label>Description :</label>
                             <input type="text" v-model="description" v-bind:class="{ 'is-invalid': error_handler && error_handler.description}" class="form-control">
                             <span v-if="error_handler.description" class=" invalid-feedback">{{ error_handler.description[0] }}</span>
                        </div> 
                    </div> 
                </div>  
              <button class="btn btn-primary">Create Roles</button>   
          </form>   
    </card>		
    </template>
    <script>
    /* eslint-disable */
    import Card from 'src/components/UIComponents/Cards/Card.vue' 
    export default {
       components: {
           Card
       },
       data(){
            return{
                 items:[],
                //input fields
                 roles_name:'',
                 description:'',
                //handler
                 error_handler:[],
                 error_exist:''
            }
        },
    
        mounted: function() {
       
       },
    
        methods:{
        
            formSubmit(e){
                 e.preventDefault();
                 this.$swal({
                         title: 'Are you sure?',
                         text: 'Do you want to save',
                         type: 'warning',
                         showCancelButton: true,
                         showCloseButton: false,
                       })
                  .then((isConfirm) => {
                       if(isConfirm === true) {
                          axios.post('api/userroles/add',{
                                             roles_name:this.roles_name,
                                            description:this.description,
                                       })
                                 .then(resp => {
                                    if(resp.data.response == 'exist'){
                                            this.error_exist = resp.data.message  
                                            console.log(resp.data.response);
                                            this.$swal('Error', 'Already exist','error')
                                    }else{
                                            console.log('response => save'); 
                                            this.$swal('Save', 'You successfully save this file', 'success')
                                            this.$router.push({name: 'users-roles'}) 
                                            this.roles_name = ''
                                            this.description = ''
                                    }                   
                                })    
                                .catch(error => {
                                    if (error.response.status == 422){
                                         this.error_handler = error.response.data.errors  
                                    }
                                   console.log('response => ',error.response.data); 
                               }); 
                           }
                     }); 
             },
            
       },
      
    }
    </script>
    <style>
         .bg-breadcrum{
                background:#fff;
             }

            .link-default-user-roles{
            color: #666;
            font-size: 16px;
            font-weight: 500;
            line-height: 1.1;
        }
        
    </style>


// WEBPACK FOOTER //
// src/components/Dashboard/Views/bp-user-roles/todo-create-roles.vue